import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=43f3fcd2"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=43f3fcd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports